import { BaseWebComponentDataProvider } from '../../../../../framework/BaseWebComponentDataProvider';

export abstract class IntegrityMonitorCustomRuleBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract createCustomRule(record: Object): Promise<Object | null>;

  public abstract updateCustomRule(record: Object): Promise<Object | null>;

  public abstract assignRulesToRuleSets(
    companyId: string,
    ruleIds: Array<string>,
    ruleSetIds: Array<string>
  ): Promise<Object | null>;
}
